import type { IMarket } from "~/types/event";

export const resolveInitialMarket = (
  markets: IMarket[],
  marketId?: string | null
): IMarket | null => {
  if (!markets.length) return null;
  if (!marketId) return markets[0];
  return markets.find((market) => market.id === marketId) ?? markets[0];
};
